<template>
  <div class="px-4 sm:px-6 lg:px-8 mb-8">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-base font-semibold leading-6 text-gray-900">{{ headerInfo.title }}</h1>
        <p class="mt-2 text-sm text-gray-700">{{ headerInfo.description }}</p>
      </div>
    </div>

    <div class="mt-6 flow-root">
      <div class="overflow-x-auto">
        <div class="inline-block min-w-full align-middle">
          <table class="min-w-full divide-y divide-gray-300">
            <thead>
              <tr>
                <th v-for="(header, index) in headers" :key="index" scope="col" class="py-3.5 px-4 text-left text-sm font-semibold text-gray-900">
                  {{ header }}
                </th>
                <th class="py-3.5 px-4 text-right text-sm font-semibold text-gray-900">Ações</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
              <tr v-for="(item, index) in data" :key="index">
                <td v-for="(field, i) in fields" :key="i" class="whitespace-nowrap px-4 py-2 text-sm text-gray-700">
                  {{ item[field] ?? '—' }}
                </td>
                <td class="whitespace-nowrap px-4 py-2 text-sm text-right">
                  <button @click="$emit('delete-item', item.id)" class="text-red-600 hover:text-red-800 text-sm">
                    Deletar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimpleList',
  props: {
    headers: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    headerInfo: {
      type: Object,
      required: false,
      default: () => ({ title: 'Listagem', description: '' })
    }
  },
  computed: {
    headerMap() {
      // Converte os headers para nomes de propriedade esperados no objeto data
      return this.headers.map(h => h.toLowerCase().replace(/[^a-z0-9_]/gi, '_'));
    }
  }
};
</script>

<style scoped>
/* Você pode personalizar o estilo aqui se quiser */
</style>
